import { Input } from "antd";
import React from "react";
import CostCard from "./costCard";
import NonCostCard from "./nonCostCard";
import Delete from "../../../assets/images/delete_icon.svg";

const   CustomizationCard = (props) => {
    const { showCost, item, index, changeCostType, selectableChange, onLabelChange, ondeleteCard, field } = props;
    const onChangeNumber = (key, e, field) => {
        const num = parseInt(e.target.value);
        selectableChange(key, num,field);
    };
    const onAddNumber = (key, field) => {
        selectableChange(key, item.num_selectable_options + 1, field);
    };
    const onSubStractNumber = (key, field) => {
        if(item.num_selectable_options > 0){
            selectableChange(key, item.num_selectable_options - 1, field);
        }
    };
    return <div className="cust_card" key={index}>
        <div className="card_head">
            <h2 className="head">{showCost ? 'Add-ons' : 'Preferences'}</h2>
            <img src={Delete} alt="" className="delete_action" onClick={()=>{ ondeleteCard(index, field); }}/>
        </div>
        <div className="name_section">
            <label>Customization Label</label>
            <Input placeholder="customization label" name="label" value={item.label} onChange={(e)=> onLabelChange(index, e, field)} />
        </div>
        <div className="card_type">
            <div className="number_sec">
                <label>How Many options are selectable?</label>
                <div className="selectable_num">
                    <Input className="" name="num_selectable_options" value={item.num_selectable_options} onChange={(e)=> onChangeNumber(index, e, field)}/>
                    <div className="add_num" onClick={()=> onAddNumber(index, field)}>+</div>
                    <div className="subs_num" onClick={()=> onSubStractNumber(index, field)}>-</div>
                </div>
            </div>
            <div className="cost_sec">
                <label>Added cost?</label>
                <div className="action_butn">
                <div className={item.has_added_cost ? "selected" : "unselected"} onClick={()=> changeCostType(index, true, field)}>Yes</div>
                <div className={!item.has_added_cost ? "selected" : "unselected"}  onClick={()=> changeCostType(index, false, field)}>No</div>
            </div>
            </div>
        </div>
        {
            showCost ?
             <CostCard {...props} /> 
             :  
             <NonCostCard {...props} />

        }
    </div>
};
export default CustomizationCard;